import React, { useCallback, useEffect, useState } from 'react'
import { WhiteBox } from '@/components/Layout'
import { Label } from 'reactstrap'
import { NumericInput } from '@/components/inputs'
import Resx from '@/components/Resx'
import { openErrorDialog } from '@/utils/dialogHelpers'
import context from '@/context'
import { Button } from '@/components/button'

const IcbsReportVersionNumber = () => {
  const [ id, setId ] = useState(0)
  const [ loading, setLoading ] = useState(true)

  useEffect(() => {
    context.api.institutionReportGroupService.getReportTemplateVersionId()
      .then(response => {
        setId(response)
        setLoading(false)
      })
      .catch(() => openErrorDialog())
  }, [setId])

  const onSave = useCallback(() => {
    setLoading(true)

    context.api.institutionReportGroupService.setReportTemplateVersionId(id)
      .then(() => setLoading(false))
      .catch(() => openErrorDialog())
  }, [id])

  const onIdChange = useCallback(value => {
    setId(value)
  }, [])

  return <WhiteBox header='Reporting.AllBanksDefinitionId'>
    <Label><Resx name={'Reporting.AllBanksDefinitionDesc'} /></Label>
    <NumericInput integerOnly value={id} onChange={onIdChange} disabled={loading} />
    <Button icon='save' className='btn btn-success' onClick={onSave}><Resx name='Common.Save' /></Button>
  </WhiteBox>
}

export { IcbsReportVersionNumber }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/icbsReportAdministration/icbsReportVersionNumber.js